import { connect } from 'react-redux'
import SlidesDrawer from './SlidesDrawer'
import slideActions from '../../dataStore/actions/slides'
import {  } from '../../dataStore/actions'
import { showSlidesUploadModal, closeSlidesMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import constants from '@bt-react/constants'
import { SlideDeck } from '../../lib/slides/types'
import selectSlideDeck from '../../dataStore/selectors/selectSlideDeck'
import { SlideCardData, SlidesDrawerProps } from './types'
import { State } from '../../dataStore/reducers/reducerType'

const getThumbnails = (deck: SlideDeck | undefined): SlideCardData[] => {

  if (deck) {

    const urlRoot = deck.brightTalkDataLocation
    return Array.from({ length: deck.numberOfSlides || 0 },
      (v, i) => ({ url: `${urlRoot}Thumbnails/Slide${i + 1}.jpg` }))

  }
  return [] as SlideCardData[]

}

type Dispatch = 'onSlideClick' | 'onAddClick' | 'onRemoveClick' | 'onClick'

const mapStateToProps = (state: State): Omit<SlidesDrawerProps, Dispatch> => ({
  hidden: state.ui.selectedDrawer !== constants.drawerType.SLIDES,
  slides: state.slides ? getThumbnails(selectSlideDeck(state)) : [],
  isLoading: state.slides.isUploading || state.slides.isProcessing,
  selectedSlide: state.slides.selectedSlide,
  presenterLayoutActive: state.layouts.presenterLayout.presenterLayoutsActive,
  mediaType: state.syncUi.mediaType
})
const mapDispatchToProps = (dispatch): Pick<SlidesDrawerProps, Dispatch> => ({
  onSlideClick: (slide) => dispatch(slideActions.slideSelect(slide)),
  onAddClick: () => dispatch(showSlidesUploadModal()),
  onRemoveClick: () => dispatch(slideActions.attemptRemoveSlides()),
  onClick: () => dispatch(closeSlidesMediaDrawer())
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidesDrawer)
